import { Routes, Route } from 'react-router-dom';
import { LuxuryHeader } from './components/LuxuryHeader';
import { LuxuryHero } from './components/LuxuryHero';
import { ResidenceSection } from './components/ResidenceSection';
import { AmenitiesShowcase } from './components/AmenitiesShowcase';
import { LocationSection } from './components/LocationSection';
import { ContactSection } from './components/ContactSection';
import { LuxuryGallery } from './components/LuxuryGallery';
import { SimpleFooter } from './components/SimpleFooter';
import { FloatingContactBar } from './components/FloatingContactBar';
import { ThankYou } from './components/ui/thank-you';

function App() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-black">
      <LuxuryHeader onContactClick={scrollToContact} />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <LuxuryHero />
              <ResidenceSection />
              <AmenitiesShowcase />
              <LuxuryGallery />
              <LocationSection />
              <ContactSection />
            </>
          }
        />
        <Route
          path="/about-us"
          element={<ResidenceSection />}
        />
        <Route
          path="/amenities"
          element={<AmenitiesShowcase />}
        />

        <Route
          path="/gallery"
          element={<LuxuryGallery />}
        />
        <Route
          path="/location"
          element={<LocationSection />}
        />
        <Route
          path="/contact"
          element={<ContactSection />}
        />
        <Route
          path="/thank-you"
          element={<ThankYou />}
        />
      </Routes>

      <SimpleFooter />
      <FloatingContactBar onContactClick={scrollToContact} />
    </div>
  );
}

export default App;
